<template>
    <!-- height-level-0 售价、弹个车标都不显示：没有弹个车金融方案 -->
    <!-- height-level-1 弹个车标显示、售价不显示：有弹个车金融方案、无售价 -->
    <!-- height-level-2 弹个车、售价都显示：有弹个车金融方案、有售价 -->
    <div class="car-item"
        :class="{
            'height-level-0': !hasTangeche,
            'height-level-1': hasTangeche && !data.price,
            'height-level-2': hasTangeche && data.price,
            'height-level-2': supportloan
        }"
        :style="{
            width: width + 'px'
        }"
        :data-id="data.id">
        <!-- 车辆图片部分 -->
        <div class="car-img-container"
            :style="{
                height: width/3*2 + 'px'
            }">
            <!-- 车辆图片 -->
            <div class="car-img-parent">
                <img v-if="vLazy" v-lazy="computedImg" />
                <img v-else :src="computedImg" />
            </div>
            <!-- 新车标 -->
            <div v-if="isNew"
                class="new-icon-parent">
                <img src="//img.souche.com/20170309/png/33d1e2f9c58a75501f15d3a9c351e618.png" />
            </div>
            <!-- 已售标 -->
            <div v-if="data.carStatus === 2"
                class="sold-icon-parent">
                <img src="//img.souche.com/20170309/png/ae4abcd0ac417154a4e0befe7fdad7a9.png" />
            </div>
            <!-- 已预订标 -->
            <div v-if="data.carStatus === 3"
                class="reserved-icon-parent">
                <img src="//img.souche.com/20170309/png/e396723127b40cc9bc292ddf63d2e2fa.png" />
            </div>
            <!-- 预售标 - 暂无 -->
            <!-- <div class="pre-icon-parent">
                <img src="" />
            </div> -->
        </div>
        <div class="car-item-content">
            <div class="car-name">{{ data.fullName }}</div>
            <div class="car-main">
                <template v-if="isToolNewTangeche">
                    <span class="car-main-item">{{ data.price || '面议' }}</span>
                    <span class="car-main-item" v-if="data.prepaidLeaseAmount">首付{{ data.prepaidLeaseAmount }}万</span>
                </template>
                <!-- 有弹个车方案显示弹个车方案 -->
                <template v-else-if="hasTangeche">
                    <span class="car-main-item">
                        <span>首付</span>
                        <span class="car-main-important">{{ data.prepaidLeaseAmount }}</span>
                        <span>万</span>
                    </span>
                    <span class="car-main-item">月供{{ data.installmentPayment }}元</span>
                </template>
                <!-- 没有弹个车方案显示售价 -->
                <span v-else-if="data.price">{{ data.price }}</span>
                <span v-else>{{ data.price }}</span>
                <!-- 支持秒贷显示秒贷方案 -->
                <template v-if="supportloan">
                    <span class="gap">|</span>
                    <span>首付</span>
                    <span class="car-main-important-loan">{{ data.prepaidLeaseAmount }}</span><span>万</span>
                </template>
            </div>
            <!-- 有弹个车方案且为二手车显示售价 -->
            <div v-if="hasTangeche && !isNew && data.price"
                class="car-ex">
                售价 {{ data.price }}元
            </div>
            <div class="car-secondary">
                <span class="car-secondary-item">{{ data.cityName }}</span>
                <!-- 二手车显示上牌与公里数 -->
                <template v-if="!isNew">
                    <span class="car-secondary-item">{{ data.year }}</span>
                    <span class="car-secondary-item">{{ data.mileage }}万公里</span>
                </template>
                <span v-else-if="data.newPriceWanStr" class="car-secondary-item">指导价 {{ data.newPriceWanStr }}万</span>
            </div>
            <div v-if="hasTangeche"
                class="tangeche-icon-parent">
                <img src="//img.souche.com/20170309/png/f0251232e5efd09e575f9bbd9811f6b6.png" />
            </div>
            <div v-if="supportloan"
                class="loan-icon-parent">
                <img src="//img.souche.com/f2e/47793ebdf74b352b51e6bc7f6e7d4159.png" />
            </div>
        </div>
    </div>
</template>

<script>
    import imgUtil from '@souche-f2e/souche-util/lib/image.js';
    export default {
        props: {
            data: {
                type: Object,
                /**
                 * 默认车辆对象
                 * @Author   Bolt
                 * @DateTime 2017-03-09T20:49:53+0800
                 * @return   {[type]}                 [description]
                 */
                default() {
                    return {}
                },
                /**
                 * 校验车辆对象
                 * @Author   Bolt
                 * @DateTime 2017-03-09T20:49:41+0800
                 * @param    {[type]}                 value [description]
                 * @return   {[type]}                       [description]
                 */
                validator(value) {
                    return true;
                }
            },
            'v-lazy': {
                type: Boolean,
                default() {
                    return !!(this.__proto__ && this.__proto__.__proto__ && this.__proto__.__proto__.$Lazyload);
                }
            },
            'width': {
                type: Number,
                default: 240
            }
        },
        computed: {
            /**
             * 是否是新车
             * 自发新车、弹个车新车都是新车
             * carType-1 自发车新车
             * carType-3 弹个车新车
             * @Author   Bolt
             * @DateTime 2017-03-09T20:06:03+0800
             * @return   {Boolean}                [description]
             */
            isNew() {
                return this.data.carType === 1 || this.data.carType === 3;
            },
            /**
             * 是否接入了弹个车金融方案
             * consignment-1 弹个车新车有弹个车金融方案
             * secLeaseStatus-3 自发车有弹个车金融方案
             * @Author   Bolt
             * @DateTime 2017-03-09T20:08:10+0800
             * @return   {Boolean}                [description]
             */
            hasTangeche() {
                return this.data.consignment === 1 || this.data.secLeaseStatus === 3 || this.isToolNewTangeche;
            },
            isToolNewTangeche() {
                return this.data.toolNewTangeche;
            },
            supportloan() {
                if (!this.hasTangeche) {
                    return this.data.supportLoan;
                }
            },
            /**
             * 图片处理
             * @Author   Bolt
             * @DateTime 2017-03-09T21:51:57+0800
             * @return   {[type]}                 [description]
             */
            computedImg() {
                return this.data.bigImage? imgUtil.formatUrl(this.data.bigImage, ~~(this.width - 2), ~~(this.width/3*2)): '';
            }
        }
    }
</script>

<style lang="less" scoped>
    .car-item {
        box-sizing: border-box;
        width: 240px;
        height: 343px;
        border: 1px solid #d9d9d9;
        background: #fff;
        position: relative;
        // 无弹个车标且无售价 -22px -29px;
        &.height-level-0 {
            height: 343px - 22px - 29px;
        }
        // 无售价 -22px
        &.height-level-1 {
            height: 343px - 22px;
        }
        &.height-level-2 {
            height: 343px;
        }
        .car-img-container {
            width: 100%;
            height: 160px;
            background: #f8f8f8;
            position: relative;
            .car-img-parent {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                }
            }
            .new-icon-parent {
                width: 40px;
                height: 24px;
                position: absolute;
                top: 0;
                left: 0;
                img {
                    width: 100%;
                }
            }
            .sold-icon-parent,
            .reserved-icon-parent {
                width: 129px;
                height: 129px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -64px 0 0 -64px;
            }
        }
        .car-item-content {
            padding: 16px 11px 24px 20px;
            .car-name {
                color: #333;
                font-size: 14px;
                line-height: 24px;
                height: 48px;
                overflow: hidden;
            }
            .car-main {
                height: 17px;
                font-size: 14px;
                line-height: 14px;
                height: 14px;
                color: #FF571A;
                margin-top: 4px;
                overflow: hidden;
                .car-main-item {
                    margin-right: 14px;
                    position: relative;
                    &:after {
                        content: '|';
                        display: block;
                        position: absolute;
                        top: 3px;
                        right: -10px;
                        height: 12px;
                        line-height: 12px;
                        color: #e6e6e6;
                    }
                    &:last-child {
                        margin-right: 0;
                        &:after {
                            display: none;
                        }
                    }
                }
                .car-main-important {
                    font-size: 16px;
                    line-height: 16px;
                    vertical-align: middle;
                    display: inline-block;
                    margin-top: -2px;
                    font-weight: bold;
                }
                .car-main-important-loan {
                    font-size: 14px;
                }
                .gap {
                    color: #dedede;
                    padding: 0 5px;
                }
            }
            .car-ex {
                height: 12px;
                line-height: 12px;
                font-size: 12px;
                color: #999;
                margin-top: 10px;
            }
            .car-secondary {
                height: 12px;
                line-height: 12px;
                font-size: 12px;
                color: #999;
                margin-top: 10px;
                overflow: hidden;
                .car-secondary-item {
                    margin-right: 14px;
                    position: relative;
                    &:after {
                        content: '|';
                        display: block;
                        position: absolute;
                        top: 3px;
                        right: -10px;
                        height: 12px;
                        line-height: 12px;
                        color: #e6e6e6;
                    }
                    &:last-child {
                        margin-right: 0;
                        &:after {
                            display: none;
                        }
                    }
                }
            }
            .tangeche-icon-parent {
                width: 58px;
                height: 19px;
                position: absolute;
                bottom: 24px;
                left: 20px;
                img {
                    width: 100%;
                }
            }
            .loan-icon-parent {
                width: 36px;
                height: 20px;
                position: absolute;
                bottom: 24px;
                left: 20px;
                img {
                    width: 100%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Default.vue?4ddca55a